// extracted by mini-css-extract-plugin
export var bodySections = "_a8-8";
export var gray = "_a8-7";
export var green = "_a8-4";
export var iconContainer = "_a8-9";
export var iconWidgetContainer = "_a8-1";
export var phoneIcon = "_a8-2";
export var red = "_a8-5";
export var statusDot = "_a8-3";
export var widgetContainer = "_a8-0";
export var yellow = "_a8-6";